var AttachmentPreviewMode;
(function (AttachmentPreviewMode) {
    AttachmentPreviewMode[AttachmentPreviewMode["None"] = 0] = "None";
    AttachmentPreviewMode[AttachmentPreviewMode["Edit"] = 1] = "Edit";
    AttachmentPreviewMode[AttachmentPreviewMode["Selected"] = 2] = "Selected";
    AttachmentPreviewMode[AttachmentPreviewMode["SelectedAndPending"] = 3] = "SelectedAndPending";
    AttachmentPreviewMode[AttachmentPreviewMode["SelectedAndSaving"] = 4] = "SelectedAndSaving";
    AttachmentPreviewMode[AttachmentPreviewMode["NotSelectedAndSaving"] = 5] = "NotSelectedAndSaving";
    AttachmentPreviewMode[AttachmentPreviewMode["OtherSaving"] = 6] = "OtherSaving";
    AttachmentPreviewMode[AttachmentPreviewMode["PendingNavigation"] = 7] = "PendingNavigation";
})(AttachmentPreviewMode || (AttachmentPreviewMode = {}));
export default AttachmentPreviewMode;
//# sourceMappingURL=AttachmentPreviewMode.js.map